import { useEffect } from "react";

export default function Grupo() {
  const grupoUrl =
    "https://chat.whatsapp.com/LVacHVX8Cm91UJ749izNKM?mode=gi_t";

  useEffect(() => {
    // Dispara evento para o GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "lead_grupo_whatsapp",
    });

    const timer = setTimeout(() => {
      window.location.href = grupoUrl;
    }, 2000);

    return () => clearTimeout(timer);
  }, [grupoUrl]);

  return (
    <div style={styles.page}>
      <div>
        <h1>🎉 Grupo VIP</h1>
        <p>Você está sendo redirecionado para o grupo...</p>

        <a href={grupoUrl} style={styles.button}>
          Entrar no Grupo
        </a>
      </div>
    </div>
  );
}

const styles = {
  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg,#075e54,#25d366)",
    color: "#fff",
    textAlign: "center",
  },
  button: {
    display: "inline-block",
    marginTop: 20,
    padding: "16px 30px",
    background: "#fff",
    color: "#25d366",
    textDecoration: "none",
    borderRadius: 50,
    fontWeight: "bold",
  },
};